import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy, forwardRef, ElementRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MatPaginator, MatSort, MatDialog } from "@angular/material";
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

import { AddGroupDialogComponent } from './add-group-dialog.component';

import { ModuleConfiguration } from '../customer.module.config';
import { TileState } from '../../pillar/dashboard/store/state/TileState';
import { StoreDataSource } from '../../core/services/StoreDataSource';
import { GroupListModel } from '../models/GroupListModel';
import { GroupModel } from '../models/GroupModel';
import * as fromStore from '../store/reducers';
import * as actions from '../../pillar/dashboard/store/actions';
import { SearchComponent } from '../../pillar/search/components/search.component';
import { TileComponent } from '../../pillar/dashboard/components/tile.component';
import { TileContainer } from '../../pillar/dashboard/services/TileContainer';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'brd-group-tile',
  providers: [{ provide: TileComponent, useExisting: forwardRef(() => GroupTileComponent) }],
  templateUrl: './group-tile.component.html',
  styleUrls: ['./group-tile.component.scss']
})
export class GroupTileComponent extends TileComponent implements OnInit, OnDestroy {
  displayedColumns = ['name'];
  dataSource: StoreDataSource<GroupListModel>;
  loading$: Observable<boolean>;
  destroyed$: Subject<boolean> = new Subject<boolean>();
  editPermission ='CustomerModule.Groups:Edit';

  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;
  @ViewChild(SearchComponent)
  search: SearchComponent;

  constructor(private store: Store<TileState<GroupListModel, GroupModel>>,
              private router: Router,
              private dialog: MatDialog,
              elementRef: ElementRef,
              private tileContainer: TileContainer) {
    super(elementRef);
    tileContainer.tileComponents.push(this);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  ngOnInit() {
    this.dataSource = new StoreDataSource<GroupListModel>(
      this.destroyed$,
      this.paginator,
      this.store,
      this.store.select(fromStore.getGroupList),
      this.store.select(fromStore.getGroupListTotalCount),
      this.store.select(fromStore.getGroupListLoading),
      (p, s, search) => new actions.QueryListAction(ModuleConfiguration.moduleName,
        GroupListModel,
        {
          page: p.pageIndex,
          pageSize: p.pageSize,
          sort: s.active,
          sortDirection: s.direction,
          searchTerm: search.searchControl.value
        }),
      this.sort,
      this.search
    );

    this.loading$ = this.store.select(fromStore.getGroupListLoading);
  }

  selectItem(item: GroupListModel) {
    this.router.navigateByUrl('group-workspace/' + item.key);
  }

  showAdd(): void {
    this.dialog.open(AddGroupDialogComponent, {
      panelClass: 'customized-dialog',
      width: '324px',
      ariaLabel: 'Add Group'
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/customer/components/group-tile.component.ts